<template>
  <div class="nt-wrap" aria-live="polite">
    <transition-group name="nt" tag="div">
      <div v-for="t in toasts" :key="t.id" class="nt-toast" @click="open(t)">
        <div class="nt-icon">{{ meta(t).icon }}</div>
        <div class="nt-body"><strong v-if="t.senderName">{{ t.senderName }}</strong> {{ t.message }}</div>
        <button class="nt-x" @click.stop="dismiss(t.id)" aria-label="Dismiss">✕</button>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { auth, db } from "@/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { typeMeta, roleOf, resolveLink } from "@/services/notificationService";

// Mounted once in App.vue (outside <router-view>): pops a toast when a notification arrives
// while you're using the app, and shows the unread count in the browser tab title.
export default {
  name: "NotificationToaster",
  data() { return { toasts: [], role: "fan", unread: 0 }; },
  created() {
    this._subs = []; this._timers = []; this._baseTitle = document.title.replace(/^\(\d+\)\s*/, "");
    this._off = onAuthStateChanged(auth, (u) => {
      this._subs.forEach((s) => s()); this._subs = []; this.toasts = []; this.unread = 0; this.setTitle();
      if (!u) return;
      this._subs.push(onSnapshot(doc(db, "user", u.uid), (s) => { this.role = roleOf(s.data()); }, () => {}));
      let first = true;
      this._subs.push(onSnapshot(
        query(collection(db, "notifications"), where("receiverId", "==", u.uid), where("read", "==", false)),
        (snap) => {
          this.unread = snap.size; this.setTitle();
          if (first) { first = false; return; } // don't toast the backlog on page load
          snap.docChanges().forEach((ch) => {
            if (ch.type !== "added" || ch.doc.metadata.hasPendingWrites) return;
            if (this.$route && this.$route.path === "/notifications") return; // already looking at them
            this.push({ id: ch.doc.id, ...ch.doc.data() });
          });
        }, () => {}));
    });
  },
  beforeDestroy() { if (this._off) this._off(); this._subs.forEach((s) => s()); this._timers.forEach(clearTimeout); },
  methods: {
    meta(t) { return typeMeta(t.type); },
    setTitle() { document.title = (this.unread ? `(${this.unread}) ` : "") + this._baseTitle; },
    push(t) {
      this.toasts = [...this.toasts, t].slice(-3);
      this._timers.push(setTimeout(() => this.dismiss(t.id), 7000));
    },
    dismiss(id) { this.toasts = this.toasts.filter((x) => x.id !== id); },
    async open(t) {
      this.dismiss(t.id);
      try { await updateDoc(doc(db, "notifications", t.id), { read: true }); } catch (e) { /* ignore */ }
      const to = resolveLink(t, this.role) || "/notifications";
      if (this.$route.path !== to) this.$router.push(to);
    },
  },
};
</script>

<style scoped>
.nt-wrap{position:fixed;right:18px;bottom:84px;z-index:9998;width:min(340px,calc(100vw - 36px));pointer-events:none}
.nt-toast{pointer-events:auto;display:flex;align-items:center;gap:10px;margin-top:8px;padding:11px 12px;background:#17131c;border:0.5px solid rgba(212,140,28,0.45);border-radius:12px;box-shadow:0 10px 28px rgba(0,0,0,0.45);color:#f5f0e8;font-size:13px;cursor:pointer;font-family:'DM Sans','Helvetica Neue',sans-serif}
.nt-icon{font-size:18px;flex:none}
.nt-body{flex:1;line-height:1.4;color:rgba(245,240,232,0.85);word-break:break-word}
.nt-body strong{color:#f5f0e8;font-weight:500}
.nt-x{background:none;border:none;color:rgba(245,240,232,0.35);cursor:pointer;font-size:12px}
.nt-enter-active,.nt-leave-active{transition:all .3s ease}
.nt-enter{opacity:0;transform:translateX(30px)}
.nt-leave-to{opacity:0;transform:translateX(30px)}
</style>